import { useState, useEffect } from "react";
import api from "../../utils/api";
import { INP, LBL, S, THEME, TblRow, TblCell, StatusBadge, tblHead, useIsMobile } from "./AdminComponents";
import { useLanguage } from "../../context/LanguageContext";

const { G, G3, O, O2 } = THEME;


const LEGACY_SECTORS_NE = [
  "शहरी योजना तथा भौतिक पूर्वाधार", "सुरक्षा तथा सार्वजनिक सुरक्षा", "खानेपानी तथा जल व्यवस्थापन",
  "फोहोर तथा प्रदूषण व्यवस्थापन", "वन, वातावरण तथा पर्यटन", "शिक्षा, अनुसन्धान तथा ज्ञान विकास",
  "शिल्प, सीप तथा उद्यमशीलता विकास", "स्वास्थ्य तथा जनस्वास्थ्य", "स्वस्थ जीवनशैली तथा उपभोक्ता हित संरक्षण",
  "खेलकुद तथा खेल प्रशिक्षण", "सूचना प्रविधि तथा स्मार्ट सिटी विकास", "मिडिया तथा सञ्चार",
  "व्यापार, उद्योग तथा आर्थिक विकास", "कृषि तथा सहकारी विकास", "विपद् व्यवस्थापन तथा जलवायु अनुकूलन",
  "कला, संस्कृति तथा पहिचान संरक्षण", "सुशासन, आर्थिक नीति तथा वित्तीय व्यवस्थापन", "सामाजिक सुरक्षा तथा समावेशी विकास",
  "महिला, बालबालिका तथा युवा विकास", "अन्तर्राष्ट्रिय सम्बन्ध तथा साझेदारी", "प्रशासन तथा संस्थागत व्यवस्थापन",
];
const LEGACY_SECTORS_EN = [
  "Urban Planning & Physical Infrastructure", "Security & Public Safety", "Water Supply & Water Management",
  "Waste & Pollution Management", "Forest, Environment & Tourism", "Education, Research & Knowledge Development",
  "Craft, Skills & Entrepreneurship Development", "Health & Public Health", "Healthy Lifestyle & Consumer Rights Protection",
  "Sports & Athletic Training", "Information Technology & Smart City Development", "Media & Communication",
  "Business, Industry & Economic Development", "Agriculture & Cooperative Development", "Disaster Management & Climate Adaptation",
  "Art, Culture & Identity Preservation", "Good Governance, Economic Policy & Financial Management", "Social Security & Inclusive Development",
  "Women, Children & Youth Development", "International Relations & Partnerships", "Administration & Institutional Management",
];
const LEGACY_SECTORS = { ne: LEGACY_SECTORS_NE, en: LEGACY_SECTORS_EN };

const CONTENT = {
  ne: {
    statTotal:        "कुल",
    statPending:       "विचाराधीन",
    statApproved:      "स्वीकृत",
    statRejected:      "अस्वीकृत",
    deltaSoFar:        "अहिलेसम्म",
    deltaReview:       "समीक्षा",
    deltaLive:         "लाइभ",
    deltaRemoved:      "हटाइएको",
    searchPlaceholder: "🔍 शीर्षक वा विवरणद्वारा खोज्नुहोस्…",
    filterAll:         "सबै स्थिति",
    filterPending:     "विचाराधीन",
    filterApproved:    "स्वीकृत",
    filterRejected:    "अस्वीकृत",
    filterAllSectors:  "सबै क्षेत्र",
    refresh:           "↻ ताजा गर्नुहोस्",
    addContributor:    "+ योगदानकर्ता थप्नुहोस्",
    colTitle:          "शीर्षक",
    colName:           "नाम",
    sectionTeam:       "टिम योगदानकर्ता",
    sectionPublic:     "सार्वजनिक योगदानकर्ता",
    colSector:         "क्षेत्र",
    colStatus:         "स्थिति",
    colSubmitted:      "पेश गरिएको",
    colActions:        "कार्य",
    loading:           "योगदानहरू लोड हुँदैछ…",
    empty:             "कुनै योगदान भेटिएन।",
    view:              "👁 हेर्नुहोस्",
    approve:           "✓ स्वीकृत",
    reject:            "✕ अस्वीकृत",
    saving:            "…",
    modalTitle:        "📝 योगदान विवरण",
    lblTitle:          "शीर्षक",
    lblDescription:    "विवरण",
    lblSector:         "क्षेत्र",
    lblStatus:         "स्थिति",
    lblSubmitted:      "पेश गरिएको",
    btnApprove:        "✓ स्वीकृत गर्नुहोस्",
    btnReject:         "✕ अस्वीकृत गर्नुहोस्",
    btnClose:          "बन्द गर्नुहोस्",
    confirmReject:     "के तपाईं यो योगदान अस्वीकृत गर्न (स्थायी रूपमा मेटाउन) निश्चित हुनुहुन्छ?",
    errLoad:           "योगदानहरू लोड गर्न असफल भयो।",
    errStatus:         "स्थिति अपडेट गर्न असफल भयो।",
    errReject:         "अस्वीकृत गर्न असफल भयो।",
    // Add Contributor modal
    addModalTitle:     "टिम योगदानकर्ता थप्नुहोस्",
    lblName:           "नाम",
    lblContribTitle:   "पद / शीर्षक",
    lblContribution:   "योगदान",
    lblBio:            "बायो डाटा",
    btnSave:           "✓ सुरक्षित गर्नुहोस्",
    btnCancel:         "रद्द गर्नुहोस्",
    selectSector:      "क्षेत्र छान्नुहोस्",
    errName:           "नाम आवश्यक छ।",
    errAdd:            "योगदानकर्ता थप्न असफल भयो।",
    savedContributor:  "टिम योगदानकर्ता थपियो।",
    locale:            "ne-NP",
  },
  en: {
    statTotal:        "Total",
    statPending:       "Pending",
    statApproved:      "Approved",
    statRejected:      "Rejected",
    deltaSoFar:        "So far",
    deltaReview:       "Review",
    deltaLive:         "Live",
    deltaRemoved:      "Removed",
    searchPlaceholder: "🔍 Search by title or description…",
    filterAll:         "All Status",
    filterPending:     "Pending",
    filterApproved:    "Approved",
    filterRejected:    "Rejected",
    filterAllSectors:  "All Sectors",
    refresh:           "↻ Refresh",
    addContributor:    "+ Add Contributor",
    colTitle:          "Title",
    colName:           "Name",
    sectionTeam:       "Team Contributors",
    sectionPublic:     "Public Contributors",
    colSector:         "Sector",
    colStatus:         "Status",
    colSubmitted:      "Submitted",
    colActions:        "Actions",
    loading:           "Loading contributions…",
    empty:             "No contributions found.",
    view:              "👁 View",
    approve:           "✓ Approve",
    reject:            "✕ Reject",
    saving:            "…",
    modalTitle:        "📝 Contribution Details",
    lblTitle:          "Title",
    lblDescription:    "Description",
    lblSector:         "Sector",
    lblStatus:         "Status",
    lblSubmitted:      "Submitted",
    btnApprove:        "✓ Approve",
    btnReject:         "✕ Reject",
    btnClose:          "Close",
    confirmReject:     "Are you sure you want to reject (permanently delete) this contribution?",
    errLoad:           "Failed to load contributions.",
    errStatus:         "Failed to update status.",
    errReject:         "Failed to reject.",
    // Add Contributor modal
    addModalTitle:     "Add Team Contributor",
    lblName:           "Name",
    lblContribTitle:   "Title / Role",
    lblContribution:   "Contribution",
    lblBio:            "Bio Data",
    btnSave:           "✓ Save",
    btnCancel:         "Cancel",
    selectSector:      "Select sector",
    errName:           "Name is required.",
    errAdd:            "Failed to add contributor.",
    savedContributor:  "Team contributor added.",
    locale:            "en-US",
  },
};

function ContributorsPage() {
  const { language } = useLanguage();
  const t = CONTENT[language] || CONTENT.en;
  const isMobile = useIsMobile();

  const [contributions, setContributions] = useState([]);

  const [sectors, setSectors]             = useState([]); // [{ _id, name, order, ... }]
  const [loading, setLoading]             = useState(true);
  const [error, setError]                 = useState("");
  const [search, setSearch]               = useState("");
  const [filterStatus, setFilterStatus]   = useState("all");
  const [filterSector, setFilterSector]   = useState("all");
  const [saving, setSaving]               = useState(null);
  const [viewModal, setViewModal]         = useState(null);

  // Add Contributor (Team Contributor) modal state
  const [showAddModal, setShowAddModal]   = useState(false);
  const [addForm, setAddForm]             = useState({ name: "", sector: "", title: "", contribution: "", bio: "" });
  const [addSaving, setAddSaving]         = useState(false);
  const [addError, setAddError]           = useState("");

  const legacyList = LEGACY_SECTORS[language] || LEGACY_SECTORS.en; // for resolving old index-based records only

  useEffect(() => { fetchContributions(); fetchSectors(); }, []);

  async function fetchContributions() {
    setLoading(true); setError("");
    try {
      const res  = await api.get("/contributions/all");
      const data = Array.isArray(res.data) ? res.data : (res.data?.data ?? []);
      const active   = data.filter(x => x.status !== "rejected");
      const rejected = data.filter(x => x.status === "rejected");
      setContributions(active);
      rejected.forEach(x => { api.delete(`/contributions/${x._id}`).catch(() => {}); });
    } catch (e) {
      setError(e.response?.data?.message || t.errLoad);
    } finally {
      setLoading(false);
    }
  }

  async function fetchSectors() {
    try {
      const res  = await api.get("/sectors");
      const data = Array.isArray(res.data) ? res.data : (res.data?.data ?? res.data?.sectors ?? []);
      const sorted = [...data].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      setSectors(sorted);
    } catch (e) {
      console.error("Error fetching sectors:", e);
    }
  }

  function contribSector(c) {
    return (c.sector !== undefined && c.sector !== null && c.sector !== "") ? c.sector : null;
  }

  
  function contribSectorLabel(c) {
    const raw = contribSector(c);
    if (raw === null) return null;
    const i = Number(raw);
    if (!Number.isNaN(i) && String(i) === String(raw).trim() && legacyList[i] !== undefined) {
      return legacyList[i]; // legacy index-based record
    }
    return raw; // current text-based record (name straight from Sectors API)
  }

  function contribName(c) {
    return c.name || null;
  }

  async function updateStatus(id, status) {
    setSaving(id);
    try {
      const res     = await api.patch(`/contributions/${id}`, { status });
      const updated = res.data?.data ?? res.data;
      setContributions(c => c.map(x => x._id === id ? { ...x, status: updated.status } : x));
    } catch (e) {
      alert(e.response?.data?.message || t.errStatus);
    } finally {
      setSaving(null);
    }
  }

  async function handleReject(id) {
    if (!window.confirm(t.confirmReject)) return;
    setSaving(id);
    try {
      await api.delete(`/contributions/${id}`);
      setContributions(c => c.filter(x => x._id !== id));
    } catch (e) {
      alert(e.response?.data?.message || t.errReject);
    } finally {
      setSaving(null);
    }
  }

  
  async function handleAddContributor(e) {
    e.preventDefault();
    if (!addForm.name.trim()) { setAddError(t.errName); return; }
    setAddSaving(true); setAddError("");
    try {
      await api.post("/contributions/team", {
        name: addForm.name.trim(),
        sector: addForm.sector || undefined,
        title: addForm.title.trim(),
        contribution: addForm.contribution.trim(),
        bio: addForm.bio.trim(),
      });
      setShowAddModal(false);
      setAddForm({ name: "", sector: "", title: "", contribution: "", bio: "" });
    } catch (e2) {
      setAddError(e2.response?.data?.message || t.errAdd);
    } finally {
      setAddSaving(false);
    }
  }

  const filtered = contributions.filter(c => {
    const q = search.toLowerCase();
    const matchSearch = c.title?.toLowerCase().includes(q) || c.description?.toLowerCase().includes(q);
    const matchStatus = filterStatus === "all" || c.status === filterStatus;
    const matchSector = filterSector === "all" || contribSectorLabel(c) === filterSector;
    return matchSearch && matchStatus && matchSector;
  });

  const stats = [
    { label: t.statTotal,    value: contributions.length,                                        icon: "📝", delta: t.deltaSoFar   },
    { label: t.statPending,  value: contributions.filter(c => c.status === "pending").length,    icon: "⏳", delta: t.deltaReview  },
    { label: t.statApproved, value: contributions.filter(c => c.status === "approved").length,   icon: "✅", delta: t.deltaLive    },
    { label: t.statRejected, value: contributions.filter(c => c.status === "rejected").length,   icon: "❌", delta: t.deltaRemoved },
  ];

  function fmt(dateStr) {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString(t.locale, { day: "numeric", month: "short", year: "numeric" });
  }

  const CONTRIB_COLS = "1.7fr 140px 160px 110px 100px 240px";
  const modalInput = { ...INP, width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb" };
  const fieldLabel = { fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 6 };
  const teamRows   = filtered.filter(c => c.type === "team");
  const publicRows = filtered.filter(c => c.type !== "team");

  function renderSection(title, rows) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>{title} <span style={{ color: "#9ca3af", fontWeight: 500 }}>({rows.length})</span></div>
        <div style={{ ...S.tableWrap, ...S.tableScroll }}>
          <div style={{ minWidth: isMobile ? 780 : undefined }}>
            <div style={tblHead(CONTRIB_COLS, isMobile)}>
              <span>{t.colTitle}</span><span>{t.colName}</span><span>{t.colSector}</span><span>{t.colStatus}</span><span>{t.colSubmitted}</span><span>{t.colActions}</span>
            </div>
            {loading && <div style={{ padding: "30px", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>{t.loading}</div>}
            {!loading && rows.length === 0 && <div style={{ padding: "30px", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>{t.empty}</div>}
            {!loading && rows.map((c, i) => (
              <TblRow key={c._id} cols={CONTRIB_COLS} isLast={i === rows.length - 1}>
                <TblCell>
                  <div style={{ minWidth: 0, width: "100%" }}>
                    <div style={{ fontWeight: 600, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.title}</div>
                    <div style={{ color: "#9ca3af", fontSize: 11, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.description}</div>
                  </div>
                </TblCell>
                <TblCell fit><span style={{ color: "#374151", fontSize: 11, whiteSpace: "nowrap" }}>{contribName(c) || "—"}</span></TblCell>
                <TblCell fit>
                  <span style={{ color: "#374151", fontSize: 11, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", maxWidth: "100%" }} title={contribSectorLabel(c) || ""}>
                    {contribSectorLabel(c) || "—"}
                  </span>
                </TblCell>
                <TblCell fit><StatusBadge status={c.status} language={language} /></TblCell>
                <TblCell fit><span style={{ color: "#6b7280", fontSize: 11, whiteSpace: "nowrap" }}>{fmt(c.createdAt)}</span></TblCell>
                <TblCell fit>
                  <div style={{ display: "flex", gap: 5 }}>
                    <button onClick={() => setViewModal(c)}
                      style={{ background: O2, border: `1px solid ${O}`, color: O, borderRadius: 5, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}>
                      {t.view}
                    </button>
                    {c.status !== "approved" && c.status !== "accepted" && (
                      <button disabled={saving === c._id} onClick={() => updateStatus(c._id, "approved")}
                        style={{ background: G3, border: `1px solid ${G}`, color: G, borderRadius: 5, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 600, opacity: saving === c._id ? 0.6 : 1, whiteSpace: "nowrap" }}>
                        {saving === c._id ? t.saving : t.approve}
                      </button>
                    )}
                    {c.status !== "rejected" && (
                      <button disabled={saving === c._id} onClick={() => handleReject(c._id)}
                        style={{ background: "rgba(239,68,68,0.1)", border: "1px solid #ef4444", color: "#ef4444", borderRadius: 5, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 600, opacity: saving === c._id ? 0.6 : 1, whiteSpace: "nowrap" }}>
                        {saving === c._id ? t.saving : t.reject}
                      </button>
                    )}
                  </div>
                </TblCell>
              </TblRow>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Stat cards: 4 on desktop, 2 on mobile */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)", gap: 10 }}>
        {stats.map(s => (
          <div key={s.label} style={S.statCard}>
            <div style={S.statIcon}>{s.icon}</div>
            <div>
              <div style={S.statVal}>{s.value}</div>
              <div style={S.statLabel}>{s.label}</div>
              <div style={S.statDelta}>{s.delta}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ ...S.card, padding: "12px 16px" }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <input placeholder={t.searchPlaceholder} value={search} onChange={e => setSearch(e.target.value)} style={{ ...INP, flex: "1 1 200px", width: "auto", minWidth: 0, maxWidth: isMobile ? "100%" : 280 }} />
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={{ ...INP, width: "auto", minWidth: 120 }}>
            <option value="all">{t.filterAll}</option>
            <option value="pending">{t.filterPending}</option>
            <option value="approved">{t.filterApproved}</option>
            <option value="rejected">{t.filterRejected}</option>
          </select>
          {/* Sector filter — sourced live from the Sectors API */}
          <select value={filterSector} onChange={e => setFilterSector(e.target.value)} style={{ ...INP, width: "auto", minWidth: 150 }}>
            <option value="all">{t.filterAllSectors}</option>
            {sectors.map(s => (
              <option key={s._id} value={s.name}>{s.name}</option>
            ))}
          </select>

          <div style={{ marginLeft: isMobile ? 0 : "auto", display: "flex", gap: 8 }}>
            <button onClick={fetchContributions} style={{ padding: "7px 14px", borderRadius: 7, background: G3, border: `1px solid ${G}`, color: G, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{t.refresh}</button>
            {/* Right-side Add Contributor button -> adds a Team Contributor directly */}
            <button onClick={() => setShowAddModal(true)} style={{ padding: "8px 16px", borderRadius: 8, background: G, border: "none", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>{t.addContributor}</button>
          </div>
        </div>
      </div>

      {error && <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid #fca5a5", borderRadius: 8, padding: "10px 16px", color: "#ef4444", fontSize: 13 }}>⚠ {error}</div>}

      {renderSection(t.sectionTeam, teamRows)}
      {renderSection(t.sectionPublic, publicRows)}

      {viewModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setViewModal(null)}>
          <div style={{ background: "#fff", borderRadius: 14, width: 480, maxWidth: "95vw", boxShadow: "0 20px 60px rgba(0,0,0,0.2)", animation: "slideUp 0.22s ease", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
            <div style={{ background: `linear-gradient(135deg, ${G} 0%, #0a5c2e 100%)`, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>{t.modalTitle}</span>
              <button onClick={() => setViewModal(null)} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", width: 26, height: 26, borderRadius: "50%", cursor: "pointer", fontSize: 14 }}>×</button>
            </div>
            <div style={{ padding: "20px 22px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <div style={LBL}>{t.lblTitle}</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>{viewModal.title}</div>
              </div>
              <div>
                <div style={LBL}>{t.lblDescription}</div>
                <div style={{ fontSize: 13, color: "#374151", lineHeight: 1.6, background: "#f9fafb", borderRadius: 8, padding: "10px 12px" }}>{viewModal.description}</div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 12 }}>
                <div><div style={LBL}>{t.lblName}</div><div style={{ fontSize: 13, color: "#374151" }}>{contribName(viewModal) || "—"}</div></div>
                <div><div style={LBL}>{t.lblSector}</div><div style={{ fontSize: 13, color: "#374151" }}>{contribSectorLabel(viewModal) || "—"}</div></div>
              </div>
              {(viewModal.email || viewModal.phone || viewModal.address) && (
                <div style={{ background: "#f9fafb", borderRadius: 8, padding: "10px 14px", display: "flex", flexDirection: "column", gap: 4 }}>
                  <div style={LBL}>{language === 'ne' ? 'सम्पर्क तथा ठेगाना' : 'Contact & Address'}</div>
                  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 12, color: "#4b5563" }}>
                    {viewModal.email && <div>✉ {viewModal.email}</div>}
                    {viewModal.phone && <div>☎ {viewModal.phone}</div>}
                    {viewModal.address && <div>📍 {viewModal.address}</div>}
                  </div>
                </div>
              )}
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 12 }}>
                <div><div style={LBL}>{t.lblStatus}</div><StatusBadge status={viewModal.status} language={language} /></div>
                <div><div style={LBL}>{t.lblSubmitted}</div><div style={{ fontSize: 13, color: "#374151" }}>{fmt(viewModal.createdAt)}</div></div>
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: isMobile ? "wrap" : "nowrap" }}>
                {viewModal.status !== "approved" && (
                  <button onClick={() => { updateStatus(viewModal._id, "approved"); setViewModal(null); }}
                    style={{ flex: isMobile ? "1 1 100%" : 1, padding: "9px", borderRadius: 8, background: G, color: "#fff", border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    {t.btnApprove}
                  </button>
                )}
                {viewModal.status !== "rejected" && (
                  <button onClick={() => { handleReject(viewModal._id); setViewModal(null); }}
                    style={{ flex: isMobile ? "1 1 100%" : 1, padding: "9px", borderRadius: 8, background: "#ef4444", color: "#fff", border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    {t.btnReject}
                  </button>
                )}
                <button onClick={() => setViewModal(null)} style={{ flex: isMobile ? "1 1 100%" : 1, padding: "9px", borderRadius: 8, background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>{t.btnClose}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Team Contributor modal */}
      {showAddModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setShowAddModal(false)}>
          <div style={{ background: "#fff", borderRadius: 14, width: 520, maxWidth: "95vw", boxShadow: "0 20px 60px rgba(0,0,0,0.2)", animation: "slideUp 0.22s ease", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
            <div style={{ background: G, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "#fff", fontSize: 15, fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}><span style={{ fontSize: 16 }}>+</span> {t.addModalTitle}</span>
              <button onClick={() => setShowAddModal(false)} style={{ background: "rgba(255,255,255,0.18)", border: "none", color: "#fff", width: 26, height: 26, borderRadius: "50%", cursor: "pointer", fontSize: 14 }}>×</button>
            </div>
            <form onSubmit={handleAddContributor} style={{ padding: "22px 24px", display: "flex", flexDirection: "column", gap: 16 }}>
              {addError && <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid #fca5a5", borderRadius: 8, padding: "8px 12px", color: "#ef4444", fontSize: 12 }}>⚠ {addError}</div>}
              <div>
                <div style={fieldLabel}>{t.lblName} *</div>
                <input required value={addForm.name} onChange={e => setAddForm(f => ({ ...f, name: e.target.value }))} style={modalInput} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 14 }}>
                <div>
                  <div style={fieldLabel}>{t.lblSector}</div>
                  <select value={addForm.sector} onChange={e => setAddForm(f => ({ ...f, sector: e.target.value }))} style={modalInput}>
                    <option value="">{t.selectSector}</option>
                    {sectors.map(s => (
                      <option key={s._id} value={s.name}>{s.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <div style={fieldLabel}>{t.lblContribTitle}</div>
                  <input value={addForm.title} onChange={e => setAddForm(f => ({ ...f, title: e.target.value }))} style={modalInput} />
                </div>
              </div>
              <div>
                <div style={fieldLabel}>{t.lblContribution}</div>
                <textarea rows={3} value={addForm.contribution} onChange={e => setAddForm(f => ({ ...f, contribution: e.target.value }))} style={{ ...modalInput, resize: "vertical" }} />
              </div>
              <div>
                <div style={fieldLabel}>{t.lblBio}</div>
                <textarea rows={3} value={addForm.bio} onChange={e => setAddForm(f => ({ ...f, bio: e.target.value }))} style={{ ...modalInput, resize: "vertical" }} />
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: isMobile ? "wrap" : "nowrap" }}>
                <button type="submit" disabled={addSaving}
                  style={{ flex: isMobile ? "1 1 100%" : 1, padding: "10px", borderRadius: 8, background: G, color: "#fff", border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer", opacity: addSaving ? 0.6 : 1 }}>
                  {addSaving ? t.saving : t.btnSave}
                </button>
                <button type="button" onClick={() => setShowAddModal(false)}
                  style={{ flex: isMobile ? "1 1 100%" : 1, padding: "10px", borderRadius: 8, background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                  {t.btnCancel}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`@keyframes slideUp { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}

export default ContributorsPage;
